import { xhr, toast, wait } from "$app/utils"
import { appStore } from "$app/store.svelte"

const pages = ["department", "assignee", "hierarchy", "my_progress"]
function createPage() {
  // const { subscribe, set, update } = writable("department")
  // return {
  //   subscribe,
  //   setPage: (newPage) => {
  //     if (pages.includes(newPage)) {
  //       update((p) => (p = newPage))
  //     }
  //   },
  //   reset: () => set("department")
  // }
}
export const page = createPage()


/**
 * Async function that updates goals
 */
export async function updateGoalsOrder(
  newGoals: GoalType[],
  goal_id: number
): Promise<void> {
  const plan_id = newGoals[0].plan_id

  try {
    const resp = await xhr.post<{ goals: GoalType[] }>(
      `/plans/${plan_id}/goals/sort_by_parent.json`,
      {
        goals: newGoals.map((g) => g.id),
        id: goal_id
      }
    )

    appStore.goals = resp.data.goals
  } catch (e) {
    toast("There was an error goals tasks", "error")
    console.error(e)

    const tempGoals = [...appStore.goals]

    await wait(20)
    appStore.goals = tempGoals
  }
}

type gType = "AnnualGoal" | "QuarterlyGoal"

export const parentTypes = {
  AnnualGoal: "LongTermGoal",
  QuarterlyGoal: "AnnualGoal"
}

export async function duplicateGoal(goal: GoalType): Promise<void> {
  try {
    const offsetY = window.pageYOffset
    const resp = await xhr.post(`/plans/${goal.plan_id}/goals/duplicate.json`, {
      id: goal.id
    })

    const newGoal = resp.data as GoalType
    appStore.goals = [...appStore.goals, newGoal]
    await wait(100)
    window.scrollBy(0, offsetY)
  } catch (e) {
    toast(`There was an error duplicating goal: ${goal.name}`, "error")
  }
}

export async function deleteGoal(goal: GoalType): Promise<void> {
  if (!confirm(`Are you sure you want to delete goal: ${goal.name}`)) return

  try {
    await xhr.delete(`/plans/${goal.plan_id}/goals/${goal.id}.json`)
    appStore.goals = appStore.goals.filter((g) => g.id !== goal.id)
    appStore.tasks = appStore.tasks.filter((t) => t.goal_id !== goal.id)
  } catch (e) {
    toast(`There was an error deleting goal: ${goal.name}`, "error")
  } finally {
  }
}

export async function deleteTask(task: TaskType): Promise<void> {
  if (!confirm(`Are you sure you want to delete task: ${task.name}`)) return

  try {
    await xhr.delete(`/plans/${task.plan_id}/tasks/${task.id}.json`)
    appStore.tasks = appStore.tasks.filter((t) => t.id !== task.id)
  } catch (e) {
    toast("There was an error deleting the task", "error")
  } finally {
  }
}
